const CARDS = [
    'MASTERCARD', 'MASTERCARDDEBIT', 'VISA', 'MAESTRO', 'AMEX', 'DINERS', 'DISCOVER', 'VISAELECTRON', 'VISADEBIT'
];

export const isOptileLoaded = state => state.optileData.loaded;

export const getPaymentMethodCards = state =>
    state.optileData.dataInit.networks?.filter(network => CARDS.includes(network.name.toUpperCase())) ?? [];
